import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Globle } from 'src/assets/globle';
import { OrderByCategory } from '../orderByCategory.model';
import { ReportsService } from '../reports.service';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { OptionService } from 'src/app/options/option.service';
import { Users } from 'src/app/options/users/users.model';
import { LocalStorageService } from 'ngx-webstorage';
import { ExportexcelService } from '../exportexcel.service';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-usertransall',
  templateUrl: './usertransall.component.html',
  styleUrls: ['./usertransall.component.css']
})
export class UsertransallComponent implements OnInit {

  reports: OrderByCategory[] = [];
  users: Users[] = [];
  displayedColumns: string[] = ['orderId', 'date', "userFullName", "transType", 'price', 'quantity', 'amount', 'prevBall', 'currBall'];
  dataSource!: MatTableDataSource<OrderByCategory>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @ViewChild('fromDate') fromDate!: ElementRef;
  @ViewChild('toDate') toDate!: ElementRef;
  spinnerOverlay = false;
  selectedUser!: string;
  lang = 'en';
  reportObj: OrderByCategory = {} as OrderByCategory;
  pageSize = 100;
  filteredOptions!: Observable<Users[]>;
  searchUsers = new FormControl();

  constructor(private service: ReportsService,
    private optionService: OptionService,
    private localStorage: LocalStorageService,
    private excelService: ExportexcelService,
    private globle: Globle) { }

  ngOnInit() {
    this.pageSize = this.globle.pageSize;
    this.getUsers();
  }

  getUsers() {
    let userId = this.localStorage.retrieve("userInfo").userId
    this.optionService.getAllCustomers(userId).subscribe(data => {
      this.users = data;
      var user = {} as Users;
      user.fullName = "الجميع";
      user.id = "0";
      this.users.unshift(user);
      this.autoCompleatFilter();
    }, error => {
      console.log(error)
    })
  }

  autoCompleatFilter() {
    this.filteredOptions = this.searchUsers.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filter(name) : this.users.slice())
      );
  }

  private _filter(name: string): Users[] {
    const filterValue = name.toLowerCase();

    return this.users.filter(option => option.fullName.toLowerCase().indexOf(filterValue) === 0);
  }

  displayFn(user: Users): string {
    return user && user.fullName ? user.fullName : '';
  }

  selectUserChange(value: any) {
    this.selectedUser = value.id;
  }

  get() {
    this.spinnerOverlay = true;
    this.service.userTransAll(this.selectedUser, this.fromDate.nativeElement.value, this.toDate.nativeElement.value).subscribe(data => {
      console.log(data)
      this.reports = data;
      this.dataSource = new MatTableDataSource(this.reports);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
        this.reports = [];
        this.dataSource = new MatTableDataSource(this.reports);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      })
  }

  onApply() {
    this.get();
  }

  getTotalCost() {
    return this.reports.map(t => t.total).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  Print() {

    const doc = new jsPDF({ filters: ["ASCIIHexEncode"] });

    doc.addFileToVFS("../../assets/Amiri/Amiri-Regular.ttf", this.globle.AmiriRegular);
    doc.addFont("../../assets/Amiri/Amiri-Regular.ttf", "Amiri", "normal");

    doc.setFont("Amiri");

    doc.setFontSize(18);
    doc.setTextColor(40);
    //doc.setFont("",'normal');

    doc.text("كشف مستخدم  ", 90, 10);
    doc.text("_________________________________", 50, 12);

    // set font
    doc.setFontSize(10);
    doc.viewerPreferences({ "Direction": "L2R" }, true);
    doc.text(" المستخدم : " + this.users.find(x => x.id == this.selectedUser)?.fullName, 150, 20, {
      isOutputRtl: true,
    });

    doc.setFontSize(10);
    doc.viewerPreferences({ "Direction": "L2R" }, true);
    doc.text(" رقم الهاتف : " + this.users.find(x => x.id == this.selectedUser)?.userName, 100, 20, {
      isOutputRtl: true,
    });

    if (this.fromDate.nativeElement.value != null && this.fromDate.nativeElement.value != ""
      && this.toDate.nativeElement.value != null && this.toDate.nativeElement.value != "") {
      doc.text(" من تاريخ : " + this.fromDate.nativeElement.value, 100, 20, {
        isOutputRtl: true
      });
      doc.text(" الى تاريخ : " + this.toDate.nativeElement.value, 50, 20, {
        isOutputRtl: true
      });
    }

    //autoTable({ html: '#orderProductTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    autoTable(doc, { html: '#usersOrderTransAllTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    //doc.save("test.pdf");
    doc.output('dataurlnewwindow');
  }

  exportAsXLSX(): void {
    var exportList = [];
    for (let i = 0; i < this.reports.length; i++) {
      var obj = {
        "رقم الطلب": this.reports[i].id,
        "التاريخ": this.reports[i].date,
        "الاسم": this.reports[i].userFullName,
        "الحركة": this.reports[i].transType,
        " المبلغ": this.reports[i].amount,
        " الرصيد السابق": this.reports[i].prevBall,
        " الرصيد الحالي": this.reports[i].currBall,

      }

      exportList.push(obj);
    }
    this.excelService.exportAsExcelFile(exportList, 'كشف طلبات مستخدم');
  }


}
